import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isMobileOnly } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';

import Styles from '../story-filters-styles.module.scss';
import * as preferencesActions from '../../../actions/preferencesActions';
import RefreshFeedButton from './RefreshFeedButton';
import SwitchViewButtons from '../SwitchViewButtons';
import SimplifiedLayoutButtons from '../SimplifiedLayoutButton';
import FilterButton from '../../Buttons/FilterButton';

import { MOBILE } from '../../../data/screenSizes';

const cx = classNames.bind(Styles);

const OpenFiltersButton = ({
  actions,
  watchlistRefresh,
  rbi,
  clickEvent,
  filterOpened,
  userNewsfeedView,
  userNewsfeedViewWeb,
  userNewsfeedViewCompact,
  userNewsfeedViewCompactWeb,
  isSearch,
  className = '',
  refreshEvent,
  onSimplifiedViewTabsClick,
  isSwitchButtonHidden,
  hasFilterPersonalisation,
  mode,
  clickTrendingEvent,
  activeTrendingEvent,
  filterBtnText,
  feedFilters,
  classname,
  isAdvancedLayoutDisabled,
  isNewsPage,
  onUserNewsfeedView = () => { },
}) => {
  const [filterBtnActive, setFilterBtnActive] = useState(false);

  // change button state from outside
  useEffect(() => {
    if (filterBtnActive !== filterOpened) setFilterBtnActive(filterOpened);
  }, [filterOpened]);

  const toggleFilter = () => {
    setFilterBtnActive((open) => !open);
    actions.toggleStoryFilters(!filterBtnActive);
    if (clickEvent) clickEvent();
  };

  useEffect(() => () => {
    actions.toggleStoryFilters(false);
  }, []);

  const currentUserNewsfeedView = isMobileOnly ? userNewsfeedView : userNewsfeedViewWeb;
  const currentUserCompactView = isMobileOnly
    ? userNewsfeedViewCompact : userNewsfeedViewCompactWeb;
  return (
    <div className={`${cx('filters-buttons-wrapper', { opened: filterBtnActive })} ${className}`}>
      <div className={cx('filters-button-container')}>
        <RefreshFeedButton
          watchlistRefresh={watchlistRefresh}
          refreshEvent={refreshEvent}
          rbi={rbi}
        />
        <button
          type="button"
          aria-label="open-filters-button"
          className={
            cx('filters-control-btn',
              'open-filters-button',
              { opened: filterBtnActive },
              { 'feed-filter': feedFilters },
              classname)
          }
          onClick={() => toggleFilter(filterBtnActive)}
        >
          <FontAwesomeIcon icon={faFilter} />
          <span>{filterBtnText || 'Filters'}</span>
        </button>
        {hasFilterPersonalisation && (
          <FilterButton
            icon={<FontAwesomeIcon icon={faUser} />}
            content={`Personalisation${mode !== MOBILE ? ' Options' : ''}`}
            onClick={clickTrendingEvent}
            className={cx('personalisation')}
            active={activeTrendingEvent}
          />
        )}
      </div>
      <div className={cx('newsfeed__layout-button-container')}>
        {onSimplifiedViewTabsClick
          && (
            <SimplifiedLayoutButtons
              onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
              isAdvancedLayoutDisabled={isAdvancedLayoutDisabled}
              isNewsPage={isNewsPage}
            />
          )}
        {!isSwitchButtonHidden && (
          <SwitchViewButtons
            isSearch={!!isSearch}
            theme="default"
            onUserNewsfeedView={onUserNewsfeedView}
            userNewsfeedView={currentUserNewsfeedView}
            userCompactView={currentUserCompactView}
            isNewsPage={isNewsPage}
          />
        )}
      </div>
    </div>
  );
};

function mapStateToProps({
  userPreferencesReducer, storyFilters,
}) {
  return {
    filterOpened: userPreferencesReducer.filterOpened,
    userSimplifiedView: storyFilters.user_newsfeed_advanced_view_web,
    userNewsfeedViewWeb: storyFilters.user_newsfeed_view_web,
    userNewsfeedView: storyFilters.user_newsfeed_view,
    userNewsfeedViewCompactWeb: storyFilters.user_newsfeed_compactview_web,
    userNewsfeedViewCompact: storyFilters.user_newsfeed_compactview,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...preferencesActions,
    }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(OpenFiltersButton);
